<template>
	<div
		class="modal fade"
		v-if="data.cod"
		id="ModalContratos"
		data-backdrop="static"
	>
		<div class="modal-dialog modal-lg" role="document">
			<div class="modal-content">
				<div class="modal-header">
					<h4 class="modal-title" id="myModalLabel">
						Objeto do contrato
					</h4>
				</div>
				<div class="modal-body">
					<div class="row">
						<div class="col-sm-2">
							<span>Código</span>
							<input
								type="text"
								disabled
								:value="data.cod"
								class="form-control"
							/>
						</div>
						<div class="col-sm-7">
							<span>Razão social</span>
							<input
								type="text"
								:value="data.cod_proposta.cnpj.razao_social"
								disabled
								class="form-control"
							/>
						</div>
						<div class="col-sm-3">
							<span>CNPJ</span>
							<input
								type="text"
								:value="data.cod_proposta.cnpj.cnpj"
								disabled
								class="form-control"
							/>
						</div>
					</div>
					<br />
					<!-- <pre>{{data.data}}</pre> -->
					<div class="row">
						<div class="col-sm-3">
							<span>Data contrato</span>
							<input
								type="text"
								:value="edate(data.data)"
								disabled
								class="form-control"
							/>
						</div>
						<div class="col-sm-2">
							<span>Vigência (Meses)</span>
							<input
								:disabled="!(data.status == 'moderacao')"
								type="number"
								v-model.number="vigencia"
								class="form-control"
							/>
						</div>
						<div class="col-sm-4">
							<span>Gestora</span>
							<select
								:disabled="!(data.status == 'moderacao')"
								class="form-control"
								v-model="cod_gestora"
							>
								<option value="0">Escolher</option>
								<option
									v-for="(gestor, index) in assets.gestores"
									:key="index"
									:value="gestor.cod"
								>
									{{ gestor.razao_social }}
								</option>
							</select>
						</div>
						<div class="col-sm-3">
							<span>Imprimir Contrato</span><br />
							<print-btn
								:data="data"
								loader="contrato"
								no-title
							/>
						</div>
					</div>
					<br />
					<div
						class="row"
						v-if="data.payment != undefined && data.payment != ''"
					>
						<div class="col-sm-2">
							<span>Forma Pagto</span>
							<input
								type="text"
								:value="
									data.payment.tPaymentTypeId == 'credit_card'
										? 'Cartão de Credito'
										: 'Boleto'
								"
								disabled
								class="form-control"
							/>
						</div>
						<div class="col-sm-3">
							<span>Dia pagamento</span>
							<input
								type="text"
								:value="edate(data.payment.tDateCreated)"
								disabled
								class="form-control"
							/>
						</div>
						<div class="col-sm-1">
							<span>Qnt.</span>
							<input
								type="text"
								:value="data.payment.tInstallments"
								disabled
								class="form-control"
							/>
						</div>

						<!-- <pre>{{}}</pre> -->
						<div class="col-sm-3">
							<span>Valor Parcela</span>
							<div class="input-group">
								<span class="input-group-addon">R$</span>
								<input
									type="text"
									style="height: 35px"
									:value="
										data.payment.tTransactionDetails
											.installment_amount
									"
									disabled
									class="form-control"
								/>
							</div>
						</div>

						<div class="col-sm-3">
							<b>Valor do contrato</b>
							<div class="input-group">
								<span class="input-group-addon">R$</span>
								<input
									type="text"
									style="height: 35px"
									disabled
									class="form-control"
									:value="
										data.payment.tTransactionDetails
											.total_paid_amount
									"
								/>
							</div>
						</div>
					</div>
					<div class="row">
						<div class="col-sm-8">
							<span>Observações</span>
							<input
								:disabled="!(data.status == 'moderacao')"
								type="text"
								class="form-control"
								v-model="obs"
							/>
						</div>
						<div class="col-sm-4">
							<span>Vendedor</span>
							<input
								type="text"
								:value="data.cod_proposta.cod_vendedor.vendedor"
								class="form-control"
								disabled
							/>
						</div>
					</div>
					<br />

					<div class="row">
						<div class="col-sm-11">
							<span>Link de ativação</span>
							<input
								disabled
								type="text"
								class="form-control"
								:value="url_activation"
							/>
						</div>
						<div class="col-sm-1">
							<br />
							<button
								@click="copiarLink(url_activation)"
								class="btn btn-primary btn-block"
							>
								<i class="fas fa-link"></i>
							</button>
						</div>
					</div>
					<br />

					<table class="table table-striped table-bordered">
						<thead-services title="Lista de Serviços Eletivos" />
						<lista-de-servicos
							:desconto="getDesconto()"
							:acrescimo="getAcrescimo()"
							:total="getTotal()"
							:data="filterListService(true)"
						/>
						<thead-services title="Lista de Serviços Eventuais" />
						<lista-de-servicos :data="filterListService(false)" />
					</table>

					<div class="clearfix"></div>
					<br />
				</div>

				<div class="modal-footer">
					<button
						type="button"
						class="btn btn-default"
						data-dismiss="modal"
						@click="closeModal"
					>
						<i class="fa fa-sign-out"></i> Sair
					</button>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import clone from 'js/clone';
	import edate from 'js/date';
	import WBS from 'js/http';
	import toastr from 'toastr';
	import reset from '../js/reset.js';
	import printBtn from 'app/printBtn';
	import ListaDeServicos from './lista-de-servicos.vue';
	import TheadServices from './thead-services.vue';

	export default {
		name: 'MdContracts',
		components: {
			printBtn,
			ListaDeServicos,
			TheadServices,
		},
		data() {
			return {
				data: clone(reset),
				vigencia: 12,
				obs: '',
				cod_gestora: 0,
				assets: {},
				status_button: false,
				desconto: '',
				acrescimo: '',
				total: '',
			};
		},
		methods: {
			copiarLink(url_activation) {
				navigator.clipboard
					.writeText(url_activation)
					.then(() => {
						alert('Link de ativação copiado com sucesso!');
					})
					.catch((erro) => {
						alert('Erro ao copiar Link de ativação.');
						console.error('Falha ao copiar texto: ', erro);
					});
			},
			edate(date) {
				if (date == '0000-00-00') {
					return '--/--/----';
				} else {
					return edate(new Date(date), 'DD/MM/YY ás HH:II');
				}
			},
			getStringFreteType(cod) {
				switch (String(cod)) {
					case '40010':
						return 'SEDEX';
					case '40045':
						return 'SEDEX A COBRAR';
					case '40215':
						return 'SEDEX 10';
					case '40290':
						return 'SEDEX HOJE';
					case '41106':
						return 'PAC';
				}
			},
			getStatus() {
				// console.log(this.data.status)
				switch (this.data.status) {
					case 'moderacao':
						return { color: 'warning', text: 'Moderação' };
						break;
					case 'novo':
						return { color: 'success', text: 'Ativo' };
						break;
					case 'ativo':
						return { color: 'info', text: 'Finalizado' };
						break;
					case 'suspenso':
						return { color: 'danger', text: 'Suspenso' };
						break;
					default:
						return { color: 'default', text: 'Indefinido' };
				}
			},
			send_actions(action) {
				// this.status_button = true
				// let sData = {
				//   cod: this.data.cod,
				//   action: action,
				//   obs: this.obs,
				//   vigencia:this.vigencia,
				//   cod_gestora: this.cod_gestora,
				//   cod_modelo: this.data.cod_modelo
				// }
				// WBS.send('private-save-sstStatusContract', sData, resp => {
				//   console.log(resp)
				//   // if(resp.status == 'success'){
				//   //  $('#ModalContratos').modal('hide')
				//   //  this.status_button = false
				//   //  this.$emit( 'updateStatusContract' )
				//   //  toastr.success('Contrato ativado com sucesso!')
				//   // }else{
				//   //  toastr.error(resp.msgs[0])
				//   //  console.log(resp)
				//   // }
				// })
			},
			filterListService(status) {
				if (this.data.cod_proposta.list_services == undefined)
					return [];
				return this.data.cod_proposta.list_services.filter(
					(item) => item.check == status
				);
			},
			open(data) {
				this.closeModal();
				this.data = clone(data);
				this.obs = data.cod_proposta.obs || '';
				this.cod_gestora = data.cod_gestora || 0;
				this.desconto = data.cod_proposta.desconto || '';
				this.acrescimo = data.cod_proposta.acrescimo || '';
				this.total = data.valor || 0;
				this.$nextTick(() => {
					$('#ModalContratos').modal('show');
				});
			},
			closeModal() {
				$('#ModalContratos').modal('hide');
				this.resetModal();
			},
			resetModal() {
				this.data = {};
				this.obs = '';
				this.cod_gestora = 0;
				this.desconto = '';
				this.acrescimo = '';
				this.total = '';
			},
			getDesconto() {
				return this.desconto;
			},
			getAcrescimo() {
				return this.acrescimo;
			},
			getTotal() {
				return this.total;
			},
			generateLink() {
				// console.log(this.data);
				const dataLink = {
					cod_app: this.data.cod_app,
					link_contrato: '',
				};

				// Convertendo o objeto para JSON
				const jsonString = JSON.stringify(dataLink);

				// Codificando em Base64
				const base64String = btoa(jsonString);
				let email = '';

				if (this.data.cod_proposta.cnpj.contatos) {
					email =
						this.data.cod_proposta.cnpj.contatos[
							this.data.cod_proposta.cnpj.contato
						].mail;
				}

				// Construindo a URL
				return `http://viasst.com.br/services/contract_activation/${base64String}?email=${email}`;
				// return `http://localhost/Viamed/viasst/services/contract_activation/${base64String}?email=${email}`;
			},
		},
		computed: {
			url_activation() {
				// console.log(this.data);
				// return `http://gestor.viasst.com.br/#/contract-activation/${this.data.cod_app}`;
				// return `http://viasst.com.br/services/contract_activation/${this.data.cod_app}`;
				return this.generateLink();
			},
		},
		mounted() {
			WBS.send('protected-read-asstesContractsSST', (resp) => {
				// console.log(resp)
				if ((resp.status = 'success')) {
					this.assets = resp.data;
				} else {
					toastr.error(resp.msgs[0]);
					console.log(resp);
				}
			});
		},
	};
</script>
<style scoped>
	#cnt-map ol li,
	#cnt-map li {
		list-style: none;
	}

	.dropdown-menu li a {
		cursor: pointer;
	}

	#myModalLabel {
		float: left;
	}
</style>



// WEBPACK FOOTER //
// src/components/contracts/components/modal.vue